import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row } from 'reactstrap';
import Breadcrumb from '../../components/Common/Breadcrumb'
import withRouter from '../../components/Common/withRouter'

import * as Yup from "yup";
import { useFormik } from "formik";

import manProfile from "../../assets/images/man_profile.png";
import womanProfile from "../../assets/images/woman_profile.png";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GetCookieData, GetCookieToken } from '../Cookie/GetCookie';

const ProfileUser = () => {

  document.title = "Profile | Flexible-Time";

  const baseURL = process.env.REACT_APP_API_CORS
  const navigate = useNavigate()
  const token = GetCookieToken("userToken")
  const user = GetCookieData("userData")
  const user_gender = user?.user_title_name

  const [userInfo, setUserInfo] = useState([])

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL+"/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        setUserInfo(res?.data?.result)
      } catch (err) {
        console.error(err);
      }
    }
    getUserInfo()
  },[])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: userInfo?.user_name,
      email: userInfo?.user_email,
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
      email: Yup.string().email().required("Please Enter Your Email")
    }),
    onSubmit: (values) => {
    }
  });

  const checkPicNullAndGender = (gender) => {
    if(!userInfo?.user_pic && (gender === "นาย")) return manProfile
    if(!userInfo?.user_pic && (gender === "นาง")) return womanProfile
    if(!userInfo?.user_pic && (gender === "นางสาว")) return womanProfile
    else return userInfo?.user_pic
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        // src={avatar}
                        src={checkPicNullAndGender(user_gender)}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="ms-3 flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{userInfo?.user_name}</h5>
                        <p className="mb-1">{userInfo?.user_email}</p>
                        <p className="mb-0">Id no: #{userInfo?.user_id}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Change User Name</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                <Col lg={4}>
                  <Label className="form-label">User Name</Label>
                  
                    <Input
                      name="username"
                      // value={name}
                      className="form-control"
                      placeholder="Enter User Name"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.username || ""}
                      invalid={
                        validation.touched.username && validation.errors.username ? true : false
                      }
                    />
                    
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                  ) : null}
                  </Col>
                  <Col lg={4} className='text-start'>
                    <Label className="form-label">Upload Image</Label>
                    <Input type='file' />
                  </Col>
                  
                  {/* <Input name="idx" value={idx} type="hidden" /> */}
                  
                  
                </Row>
                <Row className="form-group mt-2">
                  <Label className="form-label">User Email</Label>
                  <Col lg={6}>
                  <Input
                    name="email"
                    // value={name}
                    className="form-control"
                    placeholder="Enter User Email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  </Col>
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                  {/* <Input name="idx" value={idx} type="hidden" /> */}
                  </Row>
                <div className="text-end mt-4">
                <Button className='me-2' color="danger" onClick={() => navigate(-1)}>
                    Back
                  </Button>
                  <Button type="submit" color="success">
                    Update User Profile
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(ProfileUser)